var render = function render() {
  var _vm = this,
      _c = _vm._self._c;return _c('div', [_c('div', { staticStyle: { "margin-bottom": "10px" } }, [_c('div', [_vm._v("\n      X "), _c('el-input', { attrs: { "type": "number" }, on: { "change": _vm.changeX }, model: { value: _vm.x, callback: function callback($$v) {
        _vm.x = $$v;
      }, expression: "x" } })], 1), _vm._v(" "), _c('div', [_vm._v("\n      Y"), _c('el-input', { attrs: { "type": "number" }, on: { "change": _vm.changeY }, model: { value: _vm.y, callback: function callback($$v) {
        _vm.y = $$v;
      }, expression: "y" } })], 1)]), _vm._v(" "), _c('div', { staticStyle: { "text-align": "center" } }, [_c('el-button', { attrs: { "type": "primary" }, on: { "click": _vm.setPointValue } }, [_vm._v("设置成当前坐标值")])], 1)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };